import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { WhatsAppOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';
import futezapLogo from '../assets/futezap.jpg';

const { Title, Text, Paragraph } = Typography;

const Activation = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customer_id');

  const handleActivate = async (values) => {
    setLoading(true);
    try {
      const response = await api.post('/activation/activate', {
        customer_id: customerId,
        token: values.token
      });
      
      const data = response.data;
      
      if (data.success) {
        message.success('Conta ativada com sucesso!');
        window.location.href = '/login';
      } else {
        message.error(data.message || 'Código inválido');
      }
    } catch (error) {
      console.error('Erro:', error);
      message.error('Erro ao ativar conta. Tente novamente.');
    }
    setLoading(false);
  };

  const handleResendToken = async () => {
    setResendLoading(true);
    try {
      const response = await api.post('/activation/resend-token', {
        customer_id: customerId
      });
      
      const data = response.data;
      
      if (data.success) {
        message.success('Código reenviado com sucesso!');
      } else {
        message.error(data.message || 'Erro ao reenviar código');
      }
    } catch (error) {
      console.error('Erro:', error);
      message.error('Erro ao reenviar código. Tente novamente.');
    }
    setResendLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #00B96B 0%, #52c41a 100%)', padding: '20px' }}>
      <div style={{ maxWidth: 500, margin: '0 auto', paddingTop: '10vh' }}>
        <Card style={{ textAlign: 'center', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
          <div style={{ marginBottom: 24 }}>
            <img src={futezapLogo} alt="Futezap" style={{ height: 60, borderRadius: 8 }} />
          </div>
          
          <WhatsAppOutlined style={{ fontSize: 48, color: '#25D366', marginBottom: 16 }} />
          
          <Title level={2} style={{ color: '#00B96B' }}>Ativar Conta</Title>
          
          <Paragraph style={{ fontSize: 16, marginBottom: 24 }}>
            Enviamos um código de 6 dígitos para seu WhatsApp. 
            Digite o código abaixo para ativar sua conta.
          </Paragraph>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleActivate}
            style={{ textAlign: 'left' }}
          >
            <Form.Item
              name="token"
              label="Código de Ativação"
              rules={[
                { required: true, message: 'Código é obrigatório' },
                { pattern: /^\d{6}$/, message: 'Código deve ter 6 dígitos' }
              ]}
            >
              <Input 
                placeholder="000000" 
                size="large" 
                maxLength={6}
                style={{ textAlign: 'center', fontSize: 18, letterSpacing: 4 }}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={loading}
                block
                style={{ height: 50, fontSize: 16, fontWeight: 'bold', marginBottom: 16 }}
              >
                {loading ? 'Ativando...' : 'Ativar Conta'}
              </Button>
              
              <Button
                type="default"
                size="large"
                loading={resendLoading}
                block
                onClick={handleResendToken}
                style={{ height: 40 }}
              >
                {resendLoading ? 'Reenviando...' : 'Reenviar Código'}
              </Button>
            </Form.Item>
          </Form>

          <div style={{ marginTop: 16 }}>
            <Text style={{ color: '#666', fontSize: 12 }}>
              Não recebeu o código? Verifique se o número está correto e aguarde alguns minutos.
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Activation;